import axios, { type AxiosError } from "axios";
import { CLIENT_ID } from "../auth/msalConfig";
import { emitApiError } from "./errorBus";
import { authInterceptor } from "./middleware";

declare module "axios" {
  export interface AxiosRequestConfig {
    skipErrorToast?: boolean;
  }
}

export const apiClient = axios.create({
  baseURL: "/api",
});

apiClient.interceptors.request.use(authInterceptor({ scopes: [`${CLIENT_ID}/.default`] }));

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ error?: { message?: string } }>) => {
    if (error.response && !error.config?.skipErrorToast) {
      emitApiError(error.response.data?.error?.message ?? null);
    }
    return Promise.reject(error);
  },
);
